import Empresa from "@/features/contabil/common/Empresa";
import { EObrigacoesFiscaisEmpresasObrigacoesStatus } from "@/features/contabil/services/dashboard/requests/types";

export enum EObrigacoesStatus {
  red,
  green,
  white,
  without
}

export interface IObrigacoesItemData {
  label: string;
  status: EObrigacoesStatus;
  statusValue: EObrigacoesFiscaisEmpresasObrigacoesStatus;
}

export interface IObrigacoesCardItemProps {
  title: string;
  year?: number;
  label: string;
  status: EObrigacoesStatus;
  statusValue: EObrigacoesFiscaisEmpresasObrigacoesStatus;
}

export interface IObrigacoesNotification {
  year: string;
  value: number;
}

export interface IObrigacaoCardProps {
  data: IObrigacoesCardItemProps[];
  obrigacao: string;
  isMensal: boolean;
}

export interface IObrigacoesProps {
  empresa: Empresa;
  obrigacoes: IObrigacaoCardProps[];
}

export const obrigacoesDialogProvider = Symbol("obrigacoes__dialog__provider");
export const obrigacoesDialogTributosProvider = Symbol(
  "obrigacoesDialogTributosProvider"
);
